// extracted by mini-css-extract-plugin
export default {"accordion":"permission_accordion__U6MZF","transparent":"permission_transparent__jd9Uy","accordionheader":"permission_accordionheader__GO10r"};